import { useRef, useState } from 'react'
import copy from 'copy-to-clipboard'

export function useCopyToClipboard() {
  const [copied, setCopied] = useState(false)
  const copyTimer = useRef<any>(null)

  const copyToClipboard = (text: string) => {
    copy(text) // navigator.clipboard?.writeText(text)
    setCopied(true)

    clearTimeout(copyTimer.current)
    copyTimer.current = setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  return { copied, copyToClipboard }
}
